import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-single-select-combination',
    templateUrl: './filter-single-select-combination.component.html',
    styleUrls: ['./filter-single-select-combination.component.scss']
})
export class FilterSingleSelectCombinationComponent implements OnInit {
    @Input() filter: IFilter;

    public form: UntypedFormGroup;
    public dataTypeEnum = FilterOptionType;

    constructor(private filterService: FilterService) {}

    ngOnInit() {
        this.createForm();
    }

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(child: IFilter, obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        let filterVal = currentVal.filters.find(
            e => e.field == this.filter.field
        );
        if (filterVal) {
            let childFilter = filterVal.extraFilters.find(
                e => e.field == child.field
            );
            if (childFilter) {
                childFilter.selected = true;
                childFilter.options.forEach(e => (e.isSelected = false));
                let optionVal = childFilter.options.find(
                    e => e.value == obj.value
                );
                if (optionVal) {
                    optionVal.isSelected = true;
                    this.filterService.filterConfig = currentVal;
                    childFilter.added = new Date();
                    this.filterService.filterChangeEvent();
                }
            }
        }
    }

    private createForm() {
        this.form = new UntypedFormGroup({});
        this.filter.extraFilters.forEach(e => {
            this.form.addControl(
                e.field,
                new UntypedFormControl(e.options.find(e => e.isSelected))
            );
        });
    }

    get selectedOptions() {
        return this.filter.extraFilters
            ?.filter(e => e.selected)
            .map(e => e.options.find(x => x.isSelected));
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
